
































































import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import { loadStripeCheckout } from "../stripe/load-checkout";
import { countryOptions } from "../stripe/stripe_country_codes";
import StripeElements from "../stripe/stripe-elements.vue";
import AppConsts from "../../lib/appconst";

export default Vue.extend({
  name: "UpdateCreditCard",
  components: { StripeElements },
  props: {
    showEditor: Boolean,
  },
  data() {
    return {
      token: null,
      stripe: null,
      elements: null,
      card: null,
      paymentModel: {
        cardholder: null,
        coupon: null,
        addressLine1: null,
        addressLine2: null,
        city: null,
        state: null,
        zipCode: null,
        country: null,
      },
      paymentModelRules: {
        cardholder: [
          {
            required: true,
            message: "Please fill in Cardholder",
            trigger: "blur",
          },
        ],
        addressLine1: [
          {
            required: true,
            message: "Please fill in Street Address",
            trigger: "blur",
          },
        ],
        city: [
          {
            required: true,
            message: "Please fill in City",
            trigger: "blur",
          },
        ],
        state: [
          {
            required: true,
            message: "Please fill in State / Province",
            trigger: "blur",
          },
        ],
        zipCode: [
          {
            required: true,
            message: "Please fill in Postal Code",
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            message: "Please fill in Country",
            trigger: "blur",
          },
        ],
      },
      countryOptions: countryOptions,
      loading: false,
    };
  },
  computed: {
    ...mapState("billing", ["billingAccount"]),
    showModal(): any {
      return this.showEditor;
    },
    style() {
      return {
        base: {
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4",
          },
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a",
        },
      };
    },
  },
  watch: {
    showModal(newVal) {
      let context = this as any;
      if (newVal === true) {
        context.paymentModel = {
          cardholder: null,
          coupon: null,
          addressLine1: null,
          addressLine2: null,
          city: null,
          state: null,
          zipCode: null,
          country: null,
        };
      }
    },
  },
  mounted() {
    let context = this;
    loadStripeCheckout(AppConsts.stripe_pk, "v3", () => {
      context.stripe = (window as any).Stripe(AppConsts.stripe_pk);
      var elements = context.stripe.elements();
      context.card = elements.create("card", { hidePostalCode: true, style: context.style });
      context.card.mount("#update-credit-card");
      context.card.addEventListener("change", ({ error }) => {
        const displayError = document.getElementById("update-credit-card-errors");
        if (error) {
          displayError.textContent = error.message;
        } else {
          displayError.textContent = "";
        }
      });
    });
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    handleSave() {
      (this.$refs["UpdateCardForm"] as any).validate((valid) => {
        if (valid) {
        } else {
          return;
        }
      });

      let context = this as any;
      var options = {
        name: context.paymentModel.cardholder,
        address: {
          line1: context.paymentModel.addressLine1,
          city: context.paymentModel.city,
          state: context.paymentModel.state,
          postal_code: context.paymentModel.zipCode,
          country: context.paymentModel.country,
        },
      };

      if (context.paymentModel.addressLine2) {
        (options.address as any).line2 = context.paymentModel.addressLine2;
      }

      context.stripe
        .createPaymentMethod({
          type: "card",
          card: context.card,
          billing_details: options,
        })
        .then((result) => {
          if (result.paymentMethod) {
            context.token = result.token;
            context.paymentMethodCreated(result.paymentMethod);
          }
        });
    },
    paymentMethodCreated(paymentMethod) {
      let context = this;
      this.$store.dispatch("billing/updateCreditCard", { paymentMethodId: paymentMethod.id }).then((response) => {
        if (response.data.result.success === true) {
          context.$Notice.success({
            title: "Update Credit Card",
            desc: "Success! ",
          });
          context.$emit("cancel");
        } else {
          context.$Modal.error({
            title: "Account Alert: Billing Issue!",
            content: "There's a problem with the credit card information you entered. Please check the credit card and try again.",
            okText: "Retry",
            onOk: () => {},
          });
        }
      });
    },
  },
});
